import AcceItem from '@/ts/model/AcceItem'

const items = [
  new AcceItem({
    name: 'CHARA',
    type: 'chara',
    imgPath: '',
    imgSvgPath: '',
    imgSize: { w: 100, h: 100 },
    scaleLimit: { min: 1, max: 1 },
    defaultScale: 1
  }),

  new AcceItem({
    name: 'Crown',
    dispName: '王冠',
    imgPath: '/img/acce/crown.png',
    thumbPath: '/img/acce/thumb/crown.png',
    imgSvgPath: '',
    imgSize: { w: 298, h: 189 },
    scaleLimit: { min: 0.2, max: 0.7 },
    defaultScale: 0.5
  }),

  new AcceItem({
    name: 'Flower1',
    dispName: '白い花',
    imgPath: '/img/acce/flower1.png',
    thumbPath: '/img/acce/thumb/flower1.png',
    imgSvgPath: '',
    imgSize: { w: 240, h: 240 },
    scaleLimit: { min: 0.2, max: 0.7 },
    defaultScale: 0.5
  }),

  new AcceItem({
    name: 'Ribbon1',
    dispName: 'リボン青',
    imgPath: '/img/acce/rb1.png',
    thumbPath: '/img/acce/thumb/rb1.png',
    imgSvgPath: '',
    imgSize: { w: 479, h: 235 },
    scaleLimit: { min: 0.2, max: 0.7 },
    defaultScale: 0.5
  }),

  new AcceItem({
    name: 'Ribbon2',
    dispName: 'リボン赤',
    imgPath: '/img/acce/rb2.png',
    thumbPath: '/img/acce/thumb/rb2.png',
    imgSvgPath: '',
    imgSize: { w: 479, h: 235 },
    scaleLimit: { min: 0.2, max: 0.7 },
    defaultScale: 0.5
  }),

  new AcceItem({
    name: 'Ribbon3',
    dispName: 'リボン白',
    imgPath: '/img/acce/rb3.png',
    thumbPath: '/img/acce/thumb/rb3.png',
    imgSvgPath: '',
    imgSize: { w: 372, h: 120 },
    scaleLimit: { min: 0.2, max: 0.9 },
    defaultScale: 0.5
  }),

  new AcceItem({
    name: 'Cookie1',
    dispName: 'クッキー角',
    imgPath: '/img/acce/cookie1.png',
    thumbPath: '/img/acce/thumb/cookie1.png',
    imgSvgPath: '',
    imgSize: { w: 271, h: 272 },
    scaleLimit: { min: 0.2, max: 0.9 },
    defaultScale: 0.5
  }),

  new AcceItem({
    name: 'Cookie2',
    dispName: 'クッキー丸',
    imgPath: '/img/acce/cookie2.png',
    thumbPath: '/img/acce/thumb/cookie2.png',
    imgSvgPath: '',
    imgSize: { w: 340, h: 333 },
    scaleLimit: { min: 0.2, max: 0.9 },
    defaultScale: 0.5
  }),
  new AcceItem({
    name: 'Flower2',
    dispName: 'ひまわり',
    imgPath: '/img/acce/flower2.png',
    thumbPath: '/img/acce/thumb/flower2.png',
    imgSvgPath: '',
    imgSize: { w: 639, h: 1285 },
    scaleLimit: { min: 0.12, max: 0.7 },
    defaultScale: 0.5
  }),

  new AcceItem({
    name: 'Fork',
    dispName: 'フォーク',
    imgPath: '/img/acce/fork.png',
    thumbPath: '/img/acce/thumb/fork.png',
    imgSvgPath: '',
    imgSize: { w: 306, h: 842 },
    scaleLimit: { min: 0.15, max: 0.7 },
    defaultScale: 0.5
  }),
  new AcceItem({
    name: 'Spoon',
    dispName: 'スプーン',
    imgPath: '/img/acce/spoon.png',
    thumbPath: '/img/acce/thumb/spoon.png',
    imgSvgPath: '',
    imgSize: { w: 302, h: 893 },
    scaleLimit: { min: 0.15, max: 0.9 },
    defaultScale: 0.5
  }),
  new AcceItem({
    name: 'Kinoko1',
    dispName: 'きのこ',
    imgPath: '/img/acce/kinoko1.png',
    thumbPath: '/img/acce/thumb/kinoko1.png',
    imgSvgPath: '',
    imgSize: { w: 661, h: 852 },
    scaleLimit: { min: 0.12, max: 0.9 },
    defaultScale: 0.5
  })

]

const defs: {[key: string]: AcceItem} = {}
items.forEach(item => { defs[item.name] = item })

export default defs
